import { eaterSession } from "restaumatic-client/src/services/EaterSession";
function eaterLoginPaths() {
    const config = Skubacz.configuration;
    return {
        account: config.account_path,
        terms: config.terms_path,
        privacyPolicy: config.privacy_policy_path,
    };
}
function goToEaterAccount() {
    location.assign(Skubacz.configuration.account_path);
}
/** Wires the login links and the `is-eater-signed-in` class. Call only on a Site with Eater login. */
function init(locale) {
    // On every page, as a session can end between page views.
    const session = eaterSession(locale);
    session.subscribe((state) => document.documentElement.classList.toggle("is-eater-signed-in", state.status === "signed-in"));
    document.addEventListener("click", (event) => {
        var _a, _b;
        const trigger = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, ".js-eater-login");
        if (!trigger)
            return;
        event.preventDefault();
        trigger.classList.add("is-loading");
        const done = () => trigger.classList.remove("is-loading");
        void session.ready().then((state) => {
            if (state.status === "signed-in") {
                // done() first, or a page restored from bfcache keeps the link disabled.
                done();
                goToEaterAccount();
            }
            else
                import(
                /* webpackChunkName: "EaterAccounts" */ "../components/EaterLoginWrapper")
                    .then((mod) => mod.default.open())
                    .then(done, done);
        });
    });
}
export default {
    init,
    eaterLoginPaths,
    goToEaterAccount,
};
